module.exports = __webpack_public_path__ + "static/media/0321_IMG_LES_MURS_P21_UNI_PERGAMON_CHEVRON.5e9f90bc.png";